export default __webpack_public_path__ + "static/media/stop.8fc4f6f1.svg";